import { Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { useTranslationRankmi, joinKeys } from 'helpers/translations.helper'
import { prefixTranslation } from '../../monitoring/components/ExternalCourse/common'
import styles from './CourseData.module.scss'

interface CourseDataProps {
  data: ExternalCourseModelAPI
}

export const CourseData = ({ data }: CourseDataProps) => {
  const { t } = useTranslation()
  const tRelative = useTranslationRankmi({
    prefix: joinKeys(prefixTranslation, 'data'),
  })

  const cols: { text: string; value: React.ReactNode }[] = [
    { text: 'type', value: t(`${prefixTranslation}.label`) },
    { text: 'modality', value: data.modality },
    { text: 'startDate', value: data.startDate },
    { text: 'endDate', value: data.endDate },
    { text: 'institution', value: data.institution },
    { text: 'courseId', value: data.code },
    {
      text: 'additionalCode',
      value: data.additionalCode || <div className="text-center">---</div>,
    },
    { text: 'evaluations', value: data.evaluationsCount },
  ]
  return (
    <Row>
      <Col sm={12} className="font-weight-bold">
        <div className={styles.headerCardTitle}>{data.name}</div>
      </Col>
      <Col xs={12}>
        <Row className={'justify-content-center justify-content-md-start'}>
          {cols.map(({ text, value }, i) => (
            <div key={i}>
              <Col xs={12} className={styles.colTitle}>
                {tRelative(text)}
              </Col>
              <Col>{value}</Col>
            </div>
          ))}
        </Row>
      </Col>
    </Row>
  )
}

export default CourseData
